jQuery(window).on("load", function(){
    // Hero's
    jQuery(document).on("click", "#redirectJourney", function() {
        if (jQuery(".lander-hero").hasClass("hero-postcode")) {
            const postcode = jQuery(".hero-postcode #hero-postcode").val();
            const postcodeRegex = /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})$/;
            if (postcode === "") {
                fireNotyf("Please enter your postcode before continuing.", "error");
                return;
            }
            if (!postcodeRegex.test(postcode)) {
                fireNotyf("Please enter a valid postcode to continue.", "error");
                return;
            }
            let redirect = jQuery(this).data("href");
            let currentParams = new URLSearchParams(window.location.search);
            currentParams.set("postcode", postcode);
            redirectJourney(appendParams(redirect, currentParams));
            // GTM
            pushToGTM("lander_cta_redirect");
        }
        if(jQuery(".lander-hero").hasClass("hero-reg")) {
            const vehicleReg = jQuery(".hero-reg #hero-reg").val().replace(/\s+/g, '');
            let redirect = jQuery(this).data("href");
            jQuery(".lander-hero .cta-wrapper button").addClass("active");
            // AJAX request
            jQuery.ajax({
                url: ajax_object.ajaxurl,
                type: 'POST',
                data: { action: "vehicle_information", vehicleReg: vehicleReg },
                success: function(data) {
                    if(data.success == false){
                        fireNotyf("No data found for registration provided, please try again.", "error");
                        jQuery(".lander-hero .cta-wrapper button.active").removeClass("active");
                    } else {
                        // If valid, redirect to selected journey
                        // Get existing query params from the current page URL
                        let currentParams = new URLSearchParams(window.location.search);
                        // Append custom params to the current params
                        currentParams.set("regnumber", vehicleReg);
                        // Redirect with the page params joined onto the target
                        redirectJourney(appendParams(redirect, currentParams));
                    }  
                }
            });
            // GTM
            pushToGTM("lander_cta_redirect");
        }
        if(jQuery(".lander-hero").hasClass("hero-cta")) {
            let redirect = jQuery(this).data("href");
            // Get existing query params from the current page URL
            let currentParams = new URLSearchParams(window.location.search);
            // Redirect with the page params joined onto the target
            redirectJourney(appendParams(redirect, currentParams));
            // GTM
            pushToGTM("lander_cta_redirect");
        }
        if(jQuery(".lander-hero").hasClass("hero-slider")) {
            let redirect = jQuery(this).data("href");
            // Get existing query params from the current page URL
            let currentParams = new URLSearchParams(window.location.search);
            // Redirect with the page params joined onto the target
            redirectJourney(appendParams(redirect, currentParams));
            // GTM
            pushToGTM("lander_cta_redirect");
        }
        if(jQuery(".lander-hero").hasClass("hero-email")) {
            const email = jQuery(".hero-email #hero-email").val().trim();
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const optinChecked = jQuery("#hero-email-optin").length > 0 && jQuery("#hero-email-optin").is(":checked");

            if (email === "") {
                fireNotyf("Please enter your email address before continuing.", "error");
                return;
            }
            if (!emailRegex.test(email)) {
                fireNotyf("Please enter a valid email address to continue.", "error");
                return;
            }

            // Build redirect URL
            let redirect = jQuery(this).data("href");
            let currentParams = new URLSearchParams(window.location.search);
            let newUrl;

            if (jQuery(".hero-email").data("digitech") === true) {
                let gclid = currentParams.get("gclid") || "";
                let digitechParams = new URLSearchParams();
                digitechParams.set("ref1", gclid ? "Google" : "organic");
                digitechParams.set("ref2", "SW");
                digitechParams.set("ref3", gclid);
                digitechParams.set("email", email);
                newUrl = appendParams(redirect, digitechParams);
            } else {
                currentParams.set("email", email);
                newUrl = appendParams(redirect, currentParams);
            }

            // GTM - fire before redirect with delay to ensure tag sends
            pushToGTM("lander_cta_redirect");

            // If opt-in checked, subscribe to Moosend first
            if (optinChecked) {
                jQuery.ajax({
                    url: pllb_ajax.ajax_url,
                    type: "POST",
                    data: {
                        action: "pllb_moosend_subscribe",
                        nonce: pllb_ajax.nonce,
                        email: email
                    },
                    complete: function() {
                        setTimeout(function() {
                            redirectJourney(newUrl);
                        }, 300);
                    }
                });
            } else {
                setTimeout(function() {
                    redirectJourney(newUrl);
                }, 300);
            }
        }
        // GTM
        pushToGTM("lander_cta_click");
    });   
    // Show Provider Logos once slick'ed
    jQuery(".provider-logos-inner").addClass("active");
    // CTA Anchor
    jQuery(document).on("click", "a[data-anchor], .lander-hero .cta-wrapper button[data-anchor]", function(){
        if(jQuery(this).attr("data-anchor")){
            // Fetch the data-anchor attribute
            var anchorClass = jQuery(this).data('anchor');
            // Find the element with the specified class name
            var $targetElement = jQuery('.' + anchorClass);
            // Scroll to the target element if it exists
            if ($targetElement.length) {
                jQuery('html, body').animate({
                    scrollTop: $targetElement.offset().top - 50
                }, 1000); // Duration of the scroll animation
            }
        }
    }); 
});   

// joins params onto a URL that may already carry its own query string or #hash
function appendParams(url, params) {
    const query = params.toString();
    if (!query) return url;
    const hashIndex = url.indexOf("#");
    const base = hashIndex === -1 ? url : url.slice(0, hashIndex);
    const hash = hashIndex === -1 ? "" : url.slice(hashIndex);
    const separator = !base.includes("?") ? "?" : /[?&]$/.test(base) ? "" : "&";
    return base + separator + query + hash;
}

function redirectJourney(newUrl) {
    let redirectUrl = new URL(newUrl, window.location.origin);
    let currentParams = redirectUrl.searchParams;

    if (jQuery(".lander-hero").data("heading")) {
        let rawHeading = jQuery(".lander-hero").data("heading");

        // Strip HTML tags
        let cleanHeading = rawHeading.replace(/<\/?[^>]+(>|$)/g, "");

        currentParams.set("heading", cleanHeading);
    }

    // SEO Lander
    if (jQuery("#lander-main").data("ssid")) {
        if (!currentParams.has("ssid") && !currentParams.has("source")) {
            currentParams.set("ssid", jQuery("#lander-main").data("ssid"));
            currentParams.set("source", "SEO");
        }
    }

    // GTM
    pushToGTM("lander_cta");
    window.location.href = redirectUrl;
}

// GTM
jQuery(document).on("input", ".hero-postcode .input-wrapper input", function(){
    // GTM
    pushToGTM("lander_postcode_input");
});
jQuery(document).on("input", ".hero-reg .input-wrapper input", function () {
    pushToGTM("lander_reg_input");
});
jQuery(document).on("input", ".hero-email .input-wrapper input", function(){
    pushToGTM("lander_email_input");
});

// Hero Email opt-in checkbox toggle - disable button if unchecked
jQuery(document).on("change", "#hero-email-optin", function(){
    const $btn = jQuery(".hero-email #redirectJourney");
    $btn.prop("disabled", !jQuery(this).is(":checked"));
});

////// LANDER ELEMENTS //////
jQuery(window).on("load", function(){
    // Idle Popup
    let idleTime = 0;
    let idleInterval;
    var idleFor = jQuery(".idle-popup-wrapper #idle-time").val();
    function resetIdleTimer() {
        idleTime = 0;
    }
    function startIdleTimer() {
        idleInterval = setInterval(function () {
            if (++idleTime > idleFor) {
                clearInterval(idleInterval);
                jQuery(document).trigger("userIdle");
            }
        }, 1000);
    }
    // Reset if user is active
    jQuery(document).on("mousemove keypress scroll click", resetIdleTimer);
    // Start the timer
    startIdleTimer();
    jQuery(document).on("userIdle", function () {
        jQuery(".idle-popup-wrapper").addClass("active");
    });
    // Close popup if outside clicked
    jQuery(document).on("click", function (event) {
        const $popup = jQuery(".idle-popup-inner");
        const $wrapper = $popup.parent();
        if (!$popup.is(event.target) && $popup.has(event.target).length === 0 && $wrapper.hasClass("active")) {
            $wrapper.removeClass("active");
        }
    });
    jQuery(document).on("click", ".close-idle-popup", function() {
        const $popup = jQuery(".idle-popup-inner");
        const $wrapper = $popup.parent();
        $wrapper.removeClass("active");
    });
    // Callout Popup
    if(jQuery(".callout-popup-wrapper").length > 0) {
        var calloutTime = parseInt(jQuery(".callout-popup-wrapper #callout-time").val(), 10) * 1000; // convert to ms
        setTimeout(function () {
            jQuery(".callout-popup-wrapper").addClass("active");
        }, calloutTime);
    }
});

jQuery(document).on("click", ".callout-popup-wrapper #close-popup", function() {
    var popup = jQuery(this).closest('.callout-popup-wrapper');
    popup.removeClass('active');
});

jQuery(document).on("click", ".accordion-header", function() {
    var content = jQuery(this).closest('.accordion-item').find('.accordion-content');
    jQuery('.accordion-content').not(content).slideUp();
    content.slideToggle().parent().toggleClass('active');
});

////// HERO BROADBAND COMPARISON //////
var bcDebounceTimer;

// UK postcode regex - validates format before API calls
var ukPostcodeRegex = /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})$/;

// Helper to check if input contains a valid UK postcode
function bcContainsValidPostcode(input) {
    // Extract potential postcode from end of input (address format: "Street, City, POSTCODE")
    var parts = input.split(",");
    var lastPart = parts[parts.length - 1].trim();
    // Also check the raw input in case it's just a postcode
    return ukPostcodeRegex.test(lastPart) || ukPostcodeRegex.test(input.replace(/\s+/g, ' ').trim());
}

// Helper to show spinner in button
function bcShowButtonSpinner($btn) {
    if (!$btn.data("original-text")) {
        $btn.data("original-text", $btn.text());
    }
    $btn.addClass("is-loading").html('<span class="hero-bc__spinner"></span>');
}

// Helper to hide spinner and restore button text
function bcHideButtonSpinner($btn) {
    var originalText = $btn.data("original-text") || "Find deals";
    $btn.removeClass("is-loading").text(originalText);
}

jQuery(document).on("input", "#bc-postcode-input", function() {
    var val = jQuery(this).val().trim();
    var $btn = jQuery("#bcHeroSearch");
    clearTimeout(bcDebounceTimer);
    // Reset hidden fields
    jQuery("#bc-uprn").val("");
    jQuery("#bc-postcode").val("");
    jQuery("#bc-address-id").val("");
    $btn.prop("disabled", true);
    if(val.length < 5) {
        jQuery("#bc-suggestions").hide().empty();
        return;
    }

    // Validate FULL UK postcode format before making API call
    // Only fire API when a complete postcode is entered
    if (!ukPostcodeRegex.test(val)) {
        jQuery("#bc-suggestions").html('<div class="hero-bc__no-results">Please enter a valid UK postcode</div>').show();
        return;
    }

    bcDebounceTimer = setTimeout(function() {
        // Show spinner in button while fetching addresses
        bcShowButtonSpinner($btn);
        jQuery.ajax({
            url: pllb_ajax.ajax_url,
            type: "POST",
            data: {
                action: "pllb_address_search",
                nonce: pllb_ajax.nonce,
                input: val
            },
            success: function(response) {
                bcHideButtonSpinner($btn);
                if(response.success && response.data) {
                    bcRenderSuggestions(response.data.suggestions || []);
                } else {
                    jQuery("#bc-suggestions").html('<div class="hero-bc__no-results">No addresses found</div>').show();
                }
            },
            error: function() {
                bcHideButtonSpinner($btn);
                jQuery("#bc-suggestions").html('<div class="hero-bc__no-results">Error searching addresses</div>').show();
            }
        });
    }, 400);
});

function bcRenderSuggestions(suggestions) {
    var $suggestions = jQuery("#bc-suggestions");
    if(!suggestions.length) {
        $suggestions.html('<div class="hero-bc__no-results">No addresses found</div>').show();
        return;
    }
    var html = "";
    for(var i = 0; i < suggestions.length; i++) {
        var addr = suggestions[i];
        var fullAddress = addr.fullAddress || addr.address || "";
        var parts = fullAddress.split(",");
        var title = parts[0] || "";
        var subtitle = parts.slice(1).join(",").trim();
        var id = addr.addressId || addr.id || "";
        html += '<div class="hero-bc__suggestion" data-id="' + id + '" data-address="' + fullAddress.replace(/"/g, '&quot;') + '">';
        html += '<div class="hero-bc__suggestion-title">' + title + '</div>';
        if(subtitle) {
            html += '<div class="hero-bc__suggestion-subtitle">' + subtitle + '</div>';
        }
        html += '</div>';
    }
    $suggestions.html(html).show();
}

jQuery(document).on("click", ".hero-bc__suggestion", function() {
    var addressId = jQuery(this).data("id");
    var fullAddress = jQuery(this).data("address");
    var $btn = jQuery("#bcHeroSearch");
    jQuery("#bc-postcode-input").val(fullAddress);
    jQuery("#bc-suggestions").hide();
    jQuery("#bc-address-id").val(addressId);
    $btn.prop("disabled", true);
    bcShowButtonSpinner($btn);
    // Fetch UPRN
    jQuery.ajax({
        url: pllb_ajax.ajax_url,
        type: "POST",
        data: {
            action: "pllb_address_data",
            nonce: pllb_ajax.nonce,
            addressId: addressId
        },
        success: function(response) {
            if(response.success && response.data) {
                jQuery("#bc-uprn").val(response.data.uprn || "");
                jQuery("#bc-postcode").val(response.data.postcode || "");
            }
            bcHideButtonSpinner($btn);
            $btn.prop("disabled", false);
        },
        error: function() {
            bcHideButtonSpinner($btn);
            $btn.prop("disabled", false);
        }
    });
});

jQuery(document).on("click", "#bcHeroSearch", function() {
    var $btn = jQuery(this);
    var uprn = jQuery("#bc-uprn").val();
    var postcode = jQuery("#bc-postcode").val();
    // Fallback: extract postcode from input if not set
    if(!postcode) {
        postcode = jQuery("#bc-postcode-input").val().split(",").pop().trim();
    }
    if(!uprn || !postcode) return;
    var $comparison = jQuery(".pl-broadband-comparison");
    var $container = jQuery("#broadband-comparison-container");
    if($container.length) {
        $comparison.addClass("is-loading");
        $btn.prop("disabled", true);
        bcShowButtonSpinner($btn);
        jQuery("html, body").animate({
            scrollTop: $container.offset().top - 100
        }, 500);
        jQuery.ajax({
            url: plbc_ajax.ajax_url,
            type: "POST",
            data: {
                action: "plbc_fetch_offers",
                nonce: plbc_ajax.nonce,
                uprn: uprn,
                postcode: postcode
            },
            success: function(response) {
                console.log("[PLBC] Offers response:", response);
                if(response.data && response.data.offers) {
                    console.log("[PLBC] Offers:", response.data.offers);
                }
                if(response.success && response.data && response.data.html) {
                    $comparison.replaceWith(response.data.html);
                    window.plbcInitialized = false;
                    jQuery(document).trigger("plbc:loaded");
                } else {
                    $comparison.removeClass("is-loading");
                }
                bcHideButtonSpinner($btn);
                $btn.prop("disabled", false);
            },
            error: function() {
                $comparison.removeClass("is-loading");
                bcHideButtonSpinner($btn);
                $btn.prop("disabled", false);
            }
        });
    }
});

jQuery(document).on("keypress", "#bc-postcode-input", function(e) {
    if(e.which === 13) {
        e.preventDefault();
        if(!jQuery("#bcHeroSearch").prop("disabled")) {
            jQuery("#bcHeroSearch").click();
        }
    }
});

jQuery(document).on("click", function(e) {
    if(!jQuery(e.target).closest(".hero-bc__postcode-wrapper").length) {
        jQuery("#bc-suggestions").hide();
    }
});

jQuery(document).on("focus", "#bc-postcode-input", function() {
    if(jQuery("#bc-suggestions").children().length && jQuery(this).val().length >= 3) {
        jQuery("#bc-suggestions").show();
    }
});